import { isConsultationCompleted } from "~/providers/utils";
import { ProgressNotePdfExport } from "~/providers/utils/types/consultation";
import { useGetConsultationReport } from "./consultation/useGetConsultationReport";
import { useGetPatient } from "./useGetPatient";
import {
  useGetPatientZoomMeeting,
  useGetPatientZoomMeetingBillingNote,
} from "./useGetPatientZoomMeeting";

export const useGetBillingNoteExport = ({
  patientId,
  sessionId,
}: {
  patientId: string;
  sessionId: string;
}): { isLoading: boolean; data: ProgressNotePdfExport | undefined } => {
  const patientQuery = useGetPatient(patientId);

  const consultation = patientQuery.data?.consultation;
  const isConsultationComplete = isConsultationCompleted(consultation?.status);

  const sessionQuery = useGetPatientZoomMeeting({
    patientId,
    sessionId,
    enabled: !!patientId && !!sessionId,
  });

  const billingNoteQuery = useGetPatientZoomMeetingBillingNote({
    patientId,
    sessionId,
    enabled: !!patientId && !!sessionId,
  });

  const consultationReportQuery = useGetConsultationReport(consultation?.id, {
    enabled: isConsultationComplete && !!consultation?.id,
    staleTime: 5000,
  });

  const isLoading =
    patientQuery.isLoading ||
    sessionQuery.isLoading ||
    billingNoteQuery.isLoading ||
    consultationReportQuery.isLoading;

  const billingNote = billingNoteQuery.data;
  const session = sessionQuery.data;

  if (!patientQuery.data || !billingNote?.completed_at) {
    return { isLoading, data: undefined };
  }

  return {
    isLoading,
    data: {
      patient: patientQuery.data,
      noteData: billingNote.data,
      completedAt: billingNote.completed_at,
      completedBy: billingNote.completed_by,
      basicPatientInformation:
        consultationReportQuery.data?.basic_patient_information,
      actualStartTime: session?.actual_start_time,
      actualEndTime: session?.actual_end_time,
    },
  };
};
